import { isUserDetails } from '@/components/user-details/helpers/is-user-details.helper';
import { useSelector } from 'react-redux';
export function useGetUserDetails() {
    var userDetails = useSelector(function (state) { return state.widget.userDetails; });
    return isUserDetails(userDetails) ? userDetails : null;
}
